import React from 'react';
import Toast, { ToastProps } from './Toast';
type ToastContainerProps = {
  toasts: Omit<ToastProps, 'onClose'>[];
  onClose: (id: string) => void;
};
const ToastContainer = ({
  toasts,
  onClose
}: ToastContainerProps) => {
  if (toasts.length === 0) return null;
  return <div className="fixed bottom-4 right-4 z-50 flex flex-col w-auto" data-id="element-1280">
      {toasts.map(toast => <Toast key={toast.id} id={toast.id} type={toast.type} message={toast.message} onClose={onClose} data-id="element-1281" />)}
    </div>;
};
export default ToastContainer;